<template>
  <table class="award-ranking-list-section">
    <thead class="award-ranking-list-section__header">
      <tr>
        <th
          class="award-ranking-list-section__header-label award-ranking-list-section__header-label--rank"
          v-text="$tc('LinkPage.AwardPage.label.rank')"
        />
        <th
          class="award-ranking-list-section__header-label award-ranking-list-section__header-label--name"
          v-text="$tc(`LinkPage.AwardPage.label.${category}`)"
        />
        <th
          class="award-ranking-list-section__header-label award-ranking-list-section__header-label--time"
          v-if="category === 'PIT_CREW'"
          v-text="$tc('LinkPage.AwardPage.label.time')"
        />
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(rankingData, idx) in rankingDataOtherFirst"
        :key="`ranking-other-first${idx}`"
        :class="{ 'award-ranking-list-section__item-value--favorite': rankingData.favorite }"
      >
        <td
          class="award-ranking-list-section__item-value award-ranking-list-section__item-value--rank"
          v-text="rankingData.ranking"
        />
        <td
          class="award-ranking-list-section__item-value award-ranking-list-section__item-value--content"
        >
          <div class="award-ranking-list-section__item-value__inner">
            <figure><img :src="rankingData.image" alt="" /></figure>
            <p>
              <span v-text="rankingData.name" />
              <span
                v-if="rankingData.favorite"
                class="award-ranking-list-section__item-value__favorite"
              >
                <i><img :src="require('@/assets/img/AwardPage/icon_favorite.svg')" alt="" /></i>
                {{ favoriteText }}
              </span>
            </p>
          </div>
        </td>
        <td
          class="award-ranking-list-section__item-value award-ranking-list-section__item-value--time"
          v-if="category === 'PIT_CREW'"
          v-text="rankingData.time"
        />
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import { AwardRankingData } from '@/components/LinkPage/AwardPane.vue'
import useAward from '@/components/LinkPage/hooks/useAward'
import { AwardRankingCategoryType } from '@/store/stores/collectionModule/documents/award/AwardDataDocument'

/**
 * Award 1位以外のランキング セクション
 */
export default defineComponent({
  name: 'AwardRankingListSection',
  props: {
    category: {
      type: String as PropType<AwardRankingCategoryType>,
      default: 'RECOMMEND_DRIVER',
    },
    rankingDataOtherFirst: {
      type: Array as PropType<AwardRankingData[]>,
      required: true,
    },
  },
  setup(props) {
    const { getFavoriteText } = useAward()

    /**
     * お気に入りテキストを取得
     */
    const favoriteText = computed(() => getFavoriteText(props.category))

    return {
      favoriteText,
    }
  },
})
</script>

<style lang="scss" scoped>
.award-ranking-list-section {
  width: 100%;
  border-top: 1px solid #494949;

  thead {
    background: rgba(117, 117, 117, 0.9);
  }

  tbody {
    background: rgba(255, 255, 255, 0.3);
  }

  th,
  td {
    padding: min(2.13vw, 8px) min(2.67vw, 10px);
    vertical-align: middle;
  }

  figure {
    width: min(12.8vw, 48px);
    min-width: min(12.8vw, 48px);

    img {
      border-radius: 2px;
    }
  }

  &__header {
    &-label {
      color: $white70;
      font-weight: 500;
      font-size: min(3.467vw, 13px);
      line-height: 1.54;

      &--rank {
        width: min(18.13vw, 68px);
        min-width: min(18.13vw, 68px);
        text-align: center;
      }

      &--time {
        width: min(21.867vw, 82px);
        min-width: min(21.867vw, 82px);
        padding-left: 2px;
        text-align: center;
      }
    }
  }

  &__item-value {
    color: $white;
    font-weight: 500;
    line-height: 1.33;
    text-align: center;
    letter-spacing: 0.02em;
    border-top: 1px solid $black10;

    &--rank {
      width: min(18.13vw, 68px);
      min-width: min(18.13vw, 68px);
      font-size: min(4.8vw, 18px);
    }

    &--time {
      width: min(21.867vw, 82px);
      min-width: min(21.867vw, 82px);
      padding-left: 2px;
      font-size: min(4vw, 15px);
    }

    &--content {
      font-family: $fontSignup;
      font-size: min(3.73vw, 14px);
      line-height: 1.72;
      text-align: left;
    }

    &--favorite {
      .award-ranking-list-section__item-value {
        color: $green-light !important;
      }
    }

    &__inner {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      gap: min(2.67vw, 10px);

      span {
        display: block;
        width: 100%;

        &.award-ranking-list-section__item-value__favorite {
          display: flex;
          align-items: flex-start;
          justify-content: flex-start;
          gap: min(1.6vw, 6px);
          padding: min(1.067vw, 4px) 0;
          font-size: min(2.67vw, 10px);

          i {
            display: block;
            width: min(3.73vw, 14px);
            height: min(3.73vw, 14px);
          }
        }
      }
    }
  }
}
</style>
